<div class="main-modal-container">
  <div class="close-modal-container">
    <img
      (click)="closeModal()"
      src="/assets/icons/ close-modal-icon.png"
      alt=""
    />
  </div>
  <div class="modal-content">
    <h1 class="label-title">Friendly Reminder</h1>
    <label class="reminder-label-description">
      If you modify this request, the status will change to "withdrawn" and a
      new one will be created.
    </label>
    <div class="check-container">
      <div class="check" (click)="dontAskAgain = !dontAskAgain">
        <img *ngIf="dontAskAgain" src="/assets/icons/check.png" alt="" />
      </div>
      <label for="">I understand, dont’ show this again</label>
    </div>
    <button
      (click)="closeModal()"
      gbui-button
      class="buttons-outline"
      type="submit"
    >
      Edit Request
    </button>
  </div>
</div>
